
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(90),
  playerId: Number.withConstraint(x => x >= 0),
  type: Number.withConstraint(x => x >= 0),
  browserString: String.withConstraint(x => x.length <= 255),
  start: Number.withConstraint(x => x >= 0 && x <= 16777215),
  redirect: Number.withConstraint(x => x >= 0 && x <= 16777215),
  appCache: Number.withConstraint(x => x >= 0 && x <= 16777215),
  dnsTime: Number.withConstraint(x => x >= 0 && x <= 16777215),
  tcp: Number.withConstraint(x => x >= 0 && x <= 16777215),
  requestTime: Number.withConstraint(x => x >= 0 && x <= 16777215),
  responseTime: Number.withConstraint(x => x >= 0 && x <= 16777215),
  processing: Number.withConstraint(x => x >= 0 && x <= 16777215),
  load: Number.withConstraint(x => x >= 0 && x <= 16777215),
  domContentLoad: Number.withConstraint(x => x >= 0 && x <= 16777215),
  domInteractive: Number.withConstraint(x => x >= 0 && x <= 16777215),
}).And(Partial({
  customHash: String.withConstraint(x => x.length <= 32),
  country: String.withConstraint(x => x.length <= 2),
  subType: Number.withConstraint(x => x >= 0),
  caseId: Number.withConstraint(x => x >= 0),
  testId: Number.withConstraint(x => x >= 0),
  embeddedLoad: Number.withConstraint(x => x >= 0 && x <= 16777215),
  visualCompleteness: Number.withConstraint(x => x >= 0 && x <= 16777215),
  clickToLoaded: Number.withConstraint(x => x >= 0 && x <= 16777215),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(90),
  playerId: Number.withConstraint(x => x >= 0),
  type: Number.withConstraint(x => x >= 0),
  browserString: String.withConstraint(x => x.length <= 255),
  start: Number.withConstraint(x => x >= 0 && x <= 16777215),
  redirect: Number.withConstraint(x => x >= 0 && x <= 16777215),
  appCache: Number.withConstraint(x => x >= 0 && x <= 16777215),
  dnsTime: Number.withConstraint(x => x >= 0 && x <= 16777215),
  tcp: Number.withConstraint(x => x >= 0 && x <= 16777215),
  requestTime: Number.withConstraint(x => x >= 0 && x <= 16777215),
  responseTime: Number.withConstraint(x => x >= 0 && x <= 16777215),
  processing: Number.withConstraint(x => x >= 0 && x <= 16777215),
  load: Number.withConstraint(x => x >= 0 && x <= 16777215),
  domContentLoad: Number.withConstraint(x => x >= 0 && x <= 16777215),
  domInteractive: Number.withConstraint(x => x >= 0 && x <= 16777215),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
}).And(Partial({
  customHash: String.withConstraint(x => x.length <= 32),
  country: String.withConstraint(x => x.length <= 2),
  subType: Number.withConstraint(x => x >= 0),
  caseId: Number.withConstraint(x => x >= 0),
  testId: Number.withConstraint(x => x >= 0),
  embeddedLoad: Number.withConstraint(x => x >= 0 && x <= 16777215),
  visualCompleteness: Number.withConstraint(x => x >= 0 && x <= 16777215),
  clickToLoaded: Number.withConstraint(x => x >= 0 && x <= 16777215),
  zoneId: Number.withConstraint(x => x >= 0 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 90;
  